import { Locale } from "@kizmann/pico-js";
import { CrudIndex } from "#pub/crud/index.js";

export default {

    extends: CrudIndex,

    name: 'TaskIndex',

    title: Locale.trans('All tasks'),

    crud: {
        index: '/api/task',
        delete: '/api/task/delete',
    },

    urls: {
        index: 'task.index'
    },

    search: [
        'client', 'url'
    ],

    filter: [
        'token'
    ],

    sort: [
        'updated_at', 'desc'
    ],

    columns: [
        {
            type: 'string',
            prop: 'id',
            label: Locale.trans('ID'),
            visible: false,
            minWidth: 0,
            fixedWidth: 320,
        },
        {
            type: 'client',
            prop: 'token_id',
            label: Locale.trans('Client'),
            sort: true,
            width: '30%',
        },
        {
            type: 'string',
            prop: 'name',
            label: Locale.trans('Name'),
            width: '50%',
        },
        {
            type: 'string',
            prop: 'type',
            label: Locale.trans('Type'),
            sort: true,
            minWidth: 0,
            fixedWidth: 120,
        },
        {
            type: 'boolean',
            prop: 'is_done',
            label: Locale.trans('Complete'),
            sort: true,
            fixedWidth: 120,
        },
        {
            type: 'datetime',
            prop: 'updated_at',
            label: Locale.trans('Updated'),
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
        {
            type: 'datetime',
            prop: 'created_at',
            label: Locale.trans('Created'),
            visible: false,
            sort: true,
            minWidth: 0,
            fixedWidth: 160,
        },
    ],

}